//== public init for the redemption calculator package
//== reads window.calculatorData, builds the store, mounts behaviours.
//== auto-runs on DOMContentLoaded; also exported for tests / manual boot.

import { createStore } from './state.js'
import { initNavigation } from './navigate.js'
import { initInputs } from './inputs.js'
import { initRender } from './render.js'

//== root hook - prefer the scoped attribute; fall back to an unscoped wrapper so
//== handed-off markup without data-calc still boots. the fallback deliberately
//== excludes wrappers claimed by another calculator, so redemption never boots
//== into a foreign root. remove it once the back-end template carries
//== data-calc="redemption".
const ROOT_SELECTOR = '.wrapper-calc-ui[data-calc="redemption"]'
const LEGACY_ROOT_SELECTOR = '.wrapper-calc-ui:not([data-calc])'

export function initRedemptionCalculator() {
  const root =
    document.querySelector(ROOT_SELECTOR) || document.querySelector(LEGACY_ROOT_SELECTOR)
  if (!root) return null

  //== if calculatorData is absent, the calculator runs on the bundled defaults
  //== (see DEFAULT_MIN_PARTIAL_PCT in calculate.js, DEFAULT_NB_THP_WINDOW /
  //== DEFAULT_SB_WINDOW in early-redemption.js). the back-end team should
  //== always populate it in production; defaults exist as a safety net.
  const data = (typeof window !== 'undefined' && window.calculatorData) || null
  const scheme = data?.scheme ?? {}
  const store = createStore({ scheme })

  const { resetInputs } = initInputs(store, root)
  initNavigation(store, root, { resetInputs })
  initRender(store, root, scheme)

  return { store }
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRedemptionCalculator, { once: true })
  } else {
    initRedemptionCalculator()
  }
}
